import { Complex } from 'src/interfaces/complex.interface'
import { Construction } from 'src/interfaces/construction.interface'
import { RealEstate } from 'src/interfaces/realEstate.interface'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { User } from '@/interfaces/users.interface'
import { KeycloakGroup } from '@/services/keycloak.service'
import router from '@/router'

export const useStore = defineStore('main', {
  state: () => {
    return {
      allComplexes: [] as Complex[], // should be refactored and retyped as core entity, and also refactor usage in groups - handle getPage
      allRealEstates: [] as RealEstate[], // should be refactored and retyped as core entity, and also refactor usage in groups - handle getPage
      allConstructions: [] as Construction[], // should be refactored and retyped as core entity, and also refactor usage in groups - handle getPage
      currentGroup: {} as KeycloakGroup,
      currentUser: {} as User,
      activeMenuItem: ref<string[]>([]),
      nested: {
        isLoggedIn: ref<boolean>(false)
      },
      editMode: ref<boolean>(false),
      hasRoleAdmin: ref<boolean>(false),
      currentParentId: ref<string>('')
    }
  },
  persist: {
    key: 'store-key',
    storage: localStorage,
    paths: ['nested.isLoggedIn']
  },
  getters: {
    getActiveMenuItem: (state) => {
      return () => state.activeMenuItem
    },
    getLoginStatus: (state) => {
      return () => state.nested.isLoggedIn
    }
    // TODO: remove all outcommented code
    // getComplexById: (state) => {
    //   return (id: string | undefined) => state.allComplexes.find((COMPLEX) => COMPLEX.id === id)
    // },
    // getRealEstateById: (state) => {
    //   return (id: string | undefined) => state.allRealEstates.find((REALESTATE) => REALESTATE.id === id)
    // },
    // getConstructionById: (state) => {
    //   return (id: string | undefined) => state.allConstructions.find((CONSTRUCTION) => CONSTRUCTION.id === id)
    // },
    // getGroupById: (state) => {
    //   return (id: string | undefined) => (state.currentGroup.id === id ? state.currentGroup : null)
    // },
    // getUserById: (state) => {
    //   return (id: string | undefined) => (state.currentUser.id === id ? state.currentUser : null)
    // }
  },
  actions: {
    updateActiveMenuItem(value: string[]) {
      this.activeMenuItem = value
    },
    updateLoginStatus(value: boolean) {
      this.nested.isLoggedIn = value
    },
    setEditMode(value: boolean) {
      this.editMode = value
    },
    setCurrentParentId(value: string) {
      this.currentParentId = value
    },
    // findAnyById(id: string) {
    //   let result
    //   if (this.getComplexById(id)) {
    //     result = this.getComplexById(id)?.name
    //   } else if (this.getRealEstateById(id)) {
    //     result = this.getRealEstateById(id)?.name
    //   } else if (this.getConstructionById(id)) {
    //     result = this.getConstructionById(id)?.name
    //   } else if (this.getGroupById(id)) {
    //     result = this.getGroupById(id)?.name
    //   } else {
    //     result = this.getUserById(id)?.username
    //   }
    //   return result
    // },
    // findRealEstateByComplexId(id: string) {
    //   const result = this.allRealEstates.filter((REALESTATE) => REALESTATE.complexId === id)
    //   return result
    // },
    // findConstructionByComplexId(id: string) {
    //   const result = this.allConstructions.filter((CONSTRUCTION) => CONSTRUCTION.complexId === id)
    //   return result
    // },
    // findConstructionByRealEstateId(id: string) {
    //   const result = this.allConstructions.filter((CONSTRUCTION) => CONSTRUCTION.realEstateId === id)
    //   return result
    // },
    goToComplex(id: string) {
      router.push(`/my-portfolio/complexes/${id}`)
    },
    goToRealEstate(id: string) {
      router.push(`/my-portfolio/real-estates/${id}`)
    }
    // async replaceComplexInStore(complex: Complex) {
    //   const indexToReplace = this.$state.allComplexes.findIndex((c) => c.id == complex.id)
    //   if (indexToReplace !== -1) {
    //     this.$state.allComplexes[indexToReplace] = complex
    //   }
    // },
    // async deleteComplexFromStore(id: string) {
    //   try {
    //     const objIndex = this.$state.allComplexes.findIndex((complex) => complex.id === id)
    //     this.allComplexes.splice(objIndex, 1)
    //   } catch (error) {
    //     console.error(error)
    //   }
    // },
    // async replaceRealEstateInStore(realEstate: RealEstate) {
    //   const indexToReplace = this.$state.allRealEstates.findIndex((c) => c.id == realEstate.id)
    //   if (indexToReplace !== -1) {
    //     this.$state.allRealEstates[indexToReplace] = realEstate
    //   }
    // },
    // async deleteRealEstateFromStore(id: string) {
    //   try {
    //     const objIndex = this.$state.allRealEstates.findIndex((realEstate: RealEstate) => realEstate.id === id)
    //     this.allRealEstates.splice(objIndex, 1)
    //   } catch (error) {
    //     console.error(error)
    //   }
    // }
  }
})
